module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M2 32h4a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2zM16 2v28a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pause-3.js
// module id = 1337
// module chunks = 14